import { PROFILE_FULL_PATH } from "../Accounts/paths";

export const UPDATE_EMAIL_PATH = "update-email";
export const UPDATE_PHONE_PATH = "update-phone";
export const UPDATE_PROFILE_IMAGE_PATH = "update-profile-image";

export const UPDATE_EMAIL_FULL_PATH = `${PROFILE_FULL_PATH}/${UPDATE_EMAIL_PATH}`;
export const UPDATE_PHONE_FULL_PATH = `${PROFILE_FULL_PATH}/${UPDATE_PHONE_PATH}`;
export const UPDATE_PROFILE_IMAGE_FULL_PATH = `${PROFILE_FULL_PATH}/${UPDATE_PROFILE_IMAGE_PATH}`;
